import moment from "moment";

export class ShiftType {
    ShiftCode;
    ShiftDesc;
    TimeFrom;
    TimeTo;
    Color;
    AddBy;
    constructor() {
        this.ShiftCode = "";
        this.ShiftDesc = "";
        this.TimeFrom = null;
        this.TimeTo = null;
        this.Color = "";
        this.AddBy = "";
    }
}



// WEBPACK FOOTER //
// ./src/model/ShiftType.js